module.exports = require("react-slick");


//////////////////
// WEBPACK FOOTER
// external "react-slick"
// module id = 45
// module chunks = 0